
import React      from 'react';
import CSSModules from 'react-css-modules';

import SelectBox        from '../SelectBox';

import * as eventList from '../../actions/eventList';

import style from './style.scss';
import { connect } from 'react-redux';

class WebsitePositionDropDown extends React.Component {

    render() {

        const { selectedPosition, websiteDisplayPositionsAvailable } = this.props;

        return (
            <div>
                <div className={style['event-action']}>
                    Show on Website:
                </div>
                <div className={style['event-action']}>
                    <SelectBox
                        onChange={ this.props.showEventOnWebsite.bind(this, this.props.eventId) }
                        disabled={!websiteDisplayPositionsAvailable}
                        value={selectedPosition}
                        className={style['website-display-position-dropdown']}
                    >

                        <option value={ selectedPosition ? "0" : ""}>
                            {selectedPosition ? 'Hide on Website' : 'Select'}
                        </option>

                        {selectedPosition && (
                            <option value={ selectedPosition }>
                                {selectedPosition}
                            </option>)
                        }

                        {websiteDisplayPositionsAvailable.map((positionAvailable) => {
                            return (
                                <option value={positionAvailable}>{positionAvailable}</option>
                            );
                        })}

                    </SelectBox>
                </div>

            </div>
        );
    }
}

function mapStateToProps(state) {

    return state.adminEventList;
}

function mapDispatchToProps(dispatch) {

    return {
        getWebsiteAvailablePositionsForEvents() {

            dispatch(eventList.getWebsiteDisplayPositionsAvailable());
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(WebsitePositionDropDown, style));


// WEBPACK FOOTER //
// ./components/WebsitePositionDropDown/index.js